import { IItem, Items } from '@checkout/items';
import { RootState } from '@checkout/state';
import * as React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Layout } from '..';
import { fetchSelectionRequest } from '../../../reducers/checkout';

interface IConnectedProps extends Items {
  items: IItem[];
  isLoaded: boolean;
}

interface IConnectetDispatchProps {
  fetchSelectionRequest: typeof fetchSelectionRequest;
}

type Props = IConnectedProps & IConnectetDispatchProps;

class Root extends React.Component<Props, {}> {

  componentDidMount() {
    this.props.fetchSelectionRequest();
  }

  render() {
    const { isLoaded, items } = this.props;
    return isLoaded && <Layout items={items} />;
  }
}

export default compose<React.ComponentClass>(
  injectIntl,
  connect<IConnectedProps, IConnectetDispatchProps>(
    (state: RootState) => ({
      items: state.checkout.selection && state.checkout.selection.items,
      isLoaded: state.checkout.isLoaded,
    }),
    {
      fetchSelectionRequest,
    }
  ),
)(Root);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/container/Root/Root.tsx